import React from "react";
import { Modal, Button } from "react-bootstrap";

const ErrorModal = ({
  show,
  onClose,
  title = "Une erreur est survenue",
  message = "Une erreur inattendue est apparue.",
  onRetry = null,
}) => {
  const displayMessage =
    typeof message === "string"
      ? message
      : message?.message || "Une erreur inattendue est apparue.";

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton className="bg-danger text-white">
        <Modal.Title>⚠️ {title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{displayMessage}</p>
      </Modal.Body>

      <Modal.Footer>
        {onRetry && (
          <Button variant="outline-danger" onClick={onRetry}>
            Réessayer
          </Button>
        )}

        <Button variant="secondary" onClick={onClose}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
